import { render, staticRenderFns } from "./Sale.vue?vue&type=template&id=2e377efc"
import script from "./Sale.vue?vue&type=script&lang=js"
export * from "./Sale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports